import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';
import {
  CUSTOMER_EXP_PROXY_FLAG,
  toCustomerExpUrl
} from '@amfam/shared/utility/shared-services/lib/core/customer-exp-url';

/** Repoints legacy customer experience API calls at customer-exp while the flag is on. */
export const customerExpProxyInterceptor: HttpInterceptorFn = (request, next) => {
  const rewritten = toCustomerExpUrl(request.url);
  if (!rewritten || !inject(FeatureFlagService).isEnabled(CUSTOMER_EXP_PROXY_FLAG)) {
    return next(request);
  }
  return next(request.clone({ url: rewritten }));
};
